
import {AppRouter} from "./router/AppRouter";
import {Provider} from "./context/provider";

import React from "react";

function App() {
  return (
      <Provider>
        <AppRouter />
      </Provider>
  );
}

export default App;
